<template>
    <div class="page-with-top-bar">
        <div class="flex items-center justify-between mb-4">
             <v-button
                color="grey"
                icon="arrow-left"
                class="mr-8"
                size="small"
                @click="$emit('back')"
            >
                {{ $t('back') }}
            </v-button>
            <v-button @click="exportKpiDaily" color="green" :disabled="isExporting">
                <span v-if="!isExporting">{{ $t('export') }}</span>
                <span v-else>
                    <i class="fa fa-spinner fa-spin"></i> {{ $t('loading') }}...
                </span>
            </v-button>
        </div>
        <div class="panel">
            <div v-if="isLoading" class="has-text-centered my-6">
                <i class="fa fa-spinner fa-spin"></i> {{ $t('loading') }}...
            </div>
            <div v-else-if="error" class="has-text-danger my-6">
                {{ error }}
            </div>

            <div v-else-if="kpiData && kpiData.sections.length">
                <table class="kpi-table">
                    <thead>
                        <tr class="bg-dark">
                            <th colspan="13" class="bg-dark text-white">
                                {{ kpiData.title }}
                            </th>
                        </tr>
                        <tr>
                            <th colspan="2" class="bg-yellow">TASK</th>
                            <th colspan="2" class="bg-yellow">PROGRESS</th>
                            <th colspan="2" class="bg-yellow">KPI</th>
                            <th class="bg-yellow">Ud.</th>
                            <th colspan="3" class="bg-yellow">RESCHEDULED DATES</th>
                            <th colspan="3" class="bg-yellow">PLANNED DAYS</th>
                        </tr>
                    </thead>

                    <tbody v-for="section in kpiData.sections" :key="section.name">
                        <tr class="section-header-row">
                            <td colspan="13" class="section-header">{{ section.name }}</td>
                        </tr>

                        <template v-for="task in section.tasks">
                            <!-- FILA 1 -->
                            <tr :key="section.name + '-' + task.label + '-1'">
                                <td class="icon-cell" rowspan="3">
                                    <img v-if="task.icon" :src="asset('public/kpigroups/' + task.icon)" alt="" />
                                    <span v-else>
                                        {{ task.label.charAt(0).toUpperCase() }}
                                    </span>
                                </td>
                                <td rowspan="3" class="subtitle">{{ task.label }}</td>
                                <td class="bg-green text-left">TOTAL</td>
                                <td>{{ task.progress.total }}</td>
                                <td class="bg-green text-left">DESIRED</td>
                                <td>{{ task.kpi.desired }}</td>
                                <td>{{ task.unit }}</td>
                                <td class="bg-green text-left">Start</td>
                                <td>{{ task.rescheduled.start || '-' }}</td>
                                <td>Days to finish</td>
                                <td class="bg-green text-left">INICIO</td>
                                <td>{{ task.planning.start || '-' }}</td>
                                <td class="bg-green text-left">Days & % delayed</td>
                            </tr>

                            <!-- FILA 2 -->
                            <tr :key="section.name + '-' + task.label + '-2'">
                                <td class="bg-green text-left">COMPLETED</td>
                                <td>{{ task.progress.completed }}</td>
                                <td class="bg-green text-left">CURRENT</td>
                                <td>{{ task.kpi.current }}</td>
                                <td>{{ task.unit }}</td>
                                <td class="bg-green text-left">FINISH</td>
                                <td>{{ task.rescheduled.finished || '-' }}</td>
                                <td>{{ task.rescheduled.days_to_finish || '-' }}</td>
                                <td class="bg-green text-left">FIN</td>
                                <td>{{ task.planning.finished || '-' }}</td>
                                <td>
                                    {{
                                    task.planning.days_delayed != null
                                    ? task.planning.days_delayed
                                    : '-'
                                    }}
                                </td>
                            </tr>

                            <!-- FILA 3 -->
                            <tr :key="section.name + '-' + task.label + '-3'">
                                <td class="bg-green text-left">% Completed</td>
                                <td style="min-width:70px;">
                                    <div
                                        style="background:#e0e0e0; border-radius:4px; height:16px; width:100%; position:relative; overflow:hidden;">
                                        <div :style="{
                                            width: ((task.progress.percent || 0) * 100) + '%',
                                            background: '#4FADEA',
                                            height: '100%',
                                            borderRadius: '4px',
                                            transition: 'width 0.3s'
                                        }"></div>
                                        <span
                                            style="position:absolute; left:0; right:0; top:0; bottom:0; font-size:11px; line-height:16px; text-align:center; color:#222;">
                                            {{ ((task.progress.percent || 0) * 100).toFixed(1) + '%' }}
                                        </span>
                                    </div>
                                </td>
                                <td class="bg-green text-left">REQUIRED</td>
                                <td :class="{
                                    'required-pos': task.kpi.required > 0,
                                    'required-neg': task.kpi.required < 0
                                }">
                                    {{ task.kpi.required }}
                                </td>
                                <td>{{ task.unit }}</td>
                                <td colspan="2" class="bg-green">END DAY ACCORDING TO RATIO</td>
                                <td>{{ task.rescheduled.end_by_ratio || '-' }}</td>
                                <td class="bg-green text-left">PLANNED DAYS</td>
                                <td>
                                    {{
                                    task.planning.planned_days != null
                                    ? task.planning.planned_days
                                    : '-'
                                    }}
                                </td>
                                <td>
                                    {{
                                    task.planning.percent_delayed != null
                                    ? task.planning.percent_delayed + '%'
                                    : '-'
                                    }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>

            <div v-else>
                <span>No hay datos para mostrar.</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import ProjectAdminQuickButtons from '../../../../components/project-admin-quick-buttons.vue'

export default {
    components: { ProjectAdminQuickButtons },
    props: {
        groupIds: {
            type: [Array, String],
            required: true
        },
        projectId: {
            type: [Number, String],
            required: true
        },
        activityId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            kpiData: null,
            isLoading: false,
            isExporting: false,
            error: null
        }
    },
    mounted() {
        this.fetchKpiData()
    },
    methods: {
        fetchKpiData() {
            this.isLoading = true
            this.error = null
            // Si groupIds es array, pásalo como string separado por coma
            const groupIdsParam = Array.isArray(this.groupIds) ? this.groupIds.join(',') : this.groupIds
            axios
                .get(
                    `/api/v2/project/${this.projectId}/kpi-daily-table`,
                    { params: { groupIds: groupIdsParam } }
                )
                .then(r => {
                    this.kpiData = r.data.data
                })
                .catch(() => {
                    this.error = 'Error fetching KPI data'
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        exportKpiDaily() {
            this.isExporting = true;
            const groupIdsParam = Array.isArray(this.groupIds) ? this.groupIds.join(',') : this.groupIds

            axios.get(`/api/v2/project/${this.projectId}/kpi-report-daily`, {
                params: { groupIds: groupIdsParam }
            })
                .then(response => {
                    if (response.data && response.data.success && response.data.data) {
                        window.location.href = response.data.data;
                    } else {
                        this.$buefy.toast.open({ message: this.$t('error_exporting'), type: 'is-danger' });
                    }
                })
                .catch(() => {
                    this.$buefy.toast.open({ message: this.$t('error_exporting'), type: 'is-danger' });
                })
                .finally(() => {
                    this.isExporting = false;
                });
        },
    }
}
</script>

<style scoped lang="scss">
.kpi-table {
    border-collapse: collapse;
    width: 100%;
    font-size: 10px;
}

.kpi-table th,
.kpi-table td {
    border: 1px solid #444;
    padding: 4px;
    text-align: center;
    vertical-align: middle;
}

.bg-dark {
    background: #002e4d !important;
    color: #fff;
    font-weight: bold;
}

.bg-yellow {
    background: #F5C242 !important;
}

.bg-green {
    background: #9ae096;
}

.text-left {
    text-align: left;
}

.section-header-row td {
    border-bottom: 3px solid #fff;
    text-align: left;
}

.section-header {
    background: #F5C242 !important;
    font-weight: bold;
    text-align: left;
    font-size: 14px;
    padding-left: 8px;
}

.icon-cell {
    width: 50px;
}

.icon-cell img {
    display: block;
    margin: 0 auto;
    width: 32px;
    height: 32px;
    object-fit: contain;
}

.subtitle {
    text-align: left;
    font-weight: bold;
    font-size: 1.5em;
}

.required-pos {
    background: linear-gradient(to right, #fff 0%, #66cc66 100%);
}

.required-neg {
    background: linear-gradient(to right, #fff 0%, #cc6666 100%);
}

.kpi-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
}

.kpi-table th:first-child,
.kpi-table th:nth-child(2),
.kpi-table td:first-child,
.kpi-table td:nth-child(2) {
    position: sticky;
    left: 0;
    background: #fff;
    z-index: 1;
}
</style>
